import React from 'react';

import FooterLayoutComponent from '../common/layout/FooterLayoutComponent';

const MainComponent = props => (
    <main className="main">
        <div className="body">
            <div className="greeting">
                <h3>
                    Thank you for coming, our valuable DENIM PEOPLE!
                        </h3>
            </div>
            <div className="divider">
                <div className="bar"></div>
            </div>
            <div className="word">
                <h1>
                    Here is <br />
                    TCE DENIM’s <br />
                    Virtual <br />
                    Showroom!
                </h1>
            </div>
            <div className="desc">
                <p>
                    SOURCING and BUYING processes become EASIER than before like just online shopping, based on
                    our ONE-STOP DENIM PRODUCTION and DESIGN.
                        </p>
                <div class='icon-list'>
                    <ul>
                        <li>
                            <div class='img'>
                                <img src='./imgs/main/main-icon-1.png' />
                            </div>
                        </li>
                        <li>
                            <div class='img'>
                                <img src='./imgs/main/main-icon-2.png' />
                            </div>
                        </li>
                        <li>
                            <div class='img'>
                                <img src='./imgs/main/main-icon-3.png' />
                            </div>
                        </li>
                        <li>
                            <div class='img'>
                                <img src='./imgs/main/main-icon-4.png' />
                            </div>
                        </li>
                        <li>
                            <div class='img'>
                                <img src='./imgs/main/main-icon-5.png' />
                            </div>
                        </li>
                    </ul>
                </div>
                <h3>
                    24/7
                        </h3>
                <strong>
                    Showroom opens 24/7 only for you! <br />
                            We are ALWAYS here at your nearest place.
                        </strong>
            </div>
            <div className="divider">
                <div className="bar"></div>
            </div>
            <div className="notice">
                <h3>PLEASE DON'T FORGET!</h3>
                <p>
                    We are running the biggest denim mill and
                    factories in Vietnam with FULL SUSTAINABLE
                    INFRASTRUCTURE and PRODUCTION FACILITY.
                        </p>
                <strong>
                    ALL FOR YOU.
                        </strong>
            </div>
        </div>
        <FooterLayoutComponent
            {...props} />
    </main>
)

export default MainComponent;